module.exports = __webpack_public_path__ + "img/data2.59f60aa8.png";